import React, { useRef, useEffect } from 'react';
import { useVideoTrackDimensions } from '../hooks';
import { useMediaStreamTrack } from '../hooks/useMediaStreamTrack';
export const VideoTrack = ({ track, isLocal, priority, videoProps }) => {
    var _a, _b;
    const ref = useRef(null);
    const mediaStreamTrack = useMediaStreamTrack(track);
    const dimensions = useVideoTrackDimensions(track);
    const isPortrait = ((_a = dimensions === null || dimensions === void 0 ? void 0 : dimensions.height) !== null && _a !== void 0 ? _a : 0) > ((_b = dimensions === null || dimensions === void 0 ? void 0 : dimensions.width) !== null && _b !== void 0 ? _b : 0);
    useEffect(() => {
        const el = ref.current;
        el.muted = true;
        if (isRemoteTrack(track) && priority) {
            track.setPriority(priority);
        }
        track.attach(el);
        return () => {
            track.detach(el);
            el.srcObject = null;
            if (isRemoteTrack(track) && priority) {
                track.setPriority(null);
            }
        };
    }, [track, priority]);
    const isFrontFacing = (mediaStreamTrack === null || mediaStreamTrack === void 0 ? void 0 : mediaStreamTrack.getSettings().facingMode) !== 'environment';
    const style = {
        transform: isLocal && isFrontFacing ? 'rotateY(180deg)' : '',
        objectFit: isPortrait || track.name.includes('screen')
            ? 'contain'
            : 'cover'
    };
    return (React.createElement("video", Object.assign({ ref: ref, style: Object.assign({ width: '100%', height: '100%' }, style) }, videoProps)));
};
function isRemoteTrack(track) {
    return typeof track.setPriority === 'function';
}
VideoTrack.displayName = 'VideoTrack';
//# sourceMappingURL=VideoTrack.js.map